import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import getAgent from '@egjs/agent';

import App from './App';
import theme from './theme';
import GlobalStyles from './theme/GlobalStyles';
import reportWebVitals from './reportWebVitals';
import QueryProvider from './providers/QueryProvider';
import AuthProvider from './providers/AuthProvider';
import { Forbidden } from './components';
import { FORBIDDEN } from './constants';
import store from './redux/store';
import './assets/css/bridge.scss';

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.tz.setDefault(`Asia/Seoul`);

ReactDOM.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <GlobalStyles />
      {getAgent().isMobile ? (
        <Forbidden content={FORBIDDEN.MOBILE_CONTENT} />
      ) : (
        <BrowserRouter>
          <QueryProvider>
            <Provider store={store}>
              <AuthProvider />
              <App />
            </Provider>
          </QueryProvider>
        </BrowserRouter>
      )}
    </ThemeProvider>
  </React.StrictMode>,
  document.getElementById(`root`),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
